/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateDashboardRequestBody,
  UpdateDashboardRequestBody$Outbound,
  UpdateDashboardRequestBody$outboundSchema,
} from "../components/updatedashboardrequestbody.js";

export type UpdateDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateDashboardRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateDashboardRequestBody: UpdateDashboardRequestBody;
};

/** @internal */
export type UpdateDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateDashboardSecurity$outboundSchema: z.ZodMiniType<
  UpdateDashboardSecurity$Outbound,
  UpdateDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateDashboardSecurityToJSON(
  updateDashboardSecurity: UpdateDashboardSecurity,
): string {
  return JSON.stringify(
    UpdateDashboardSecurity$outboundSchema.parse(updateDashboardSecurity),
  );
}

/** @internal */
export type UpdateDashboardRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateDashboardRequestBody: UpdateDashboardRequestBody$Outbound;
};

/** @internal */
export const UpdateDashboardRequest$outboundSchema: z.ZodMiniType<
  UpdateDashboardRequest$Outbound,
  UpdateDashboardRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateDashboardRequestBody: UpdateDashboardRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateDashboardRequestBody: "UpdateDashboardRequestBody",
    });
  }),
);

export function updateDashboardRequestToJSON(
  updateDashboardRequest: UpdateDashboardRequest,
): string {
  return JSON.stringify(
    UpdateDashboardRequest$outboundSchema.parse(updateDashboardRequest),
  );
}
